/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type IntlService from "ember-intl/services/intl";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import PersonalNotesChangedJournalEvent from "parog-web/models/personal-notes-changed-journal-event";

export default class PersonalNotesEditionFormComponent extends CrudJournalEventBaseComponent {
  @service declare intl: IntlService;

  static forcDisplayName = "Mes notes";
  static fullComponentId = "personal-notes/edition-form";

  static journalEventClass = PersonalNotesChangedJournalEvent;
  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  afterLoad(): void {
    const lastPersonalNoteJE = this.patient.personalNotesChangedJournalEvent;

    if (lastPersonalNoteJE) {
      this.changeset.set("note", lastPersonalNoteJE.note);
    }
  }
}
